function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "citadel-logo",
  fill: "#002E6D"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 16.81,
  width: 45.98,
  height: 6.62
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0.43,
  width: 9.2,
  height: 6.62
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 18.39,
  y: 0.43,
  width: 9.2,
  height: 6.62
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 36.78,
  y: 0.43,
  width: 9.2,
  height: 6.62
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 8.62,
  width: 22.2,
  height: 6.61
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 23.78,
  y: 8.62,
  width: 22.2,
  height: 6.61
}))));

var SvgCitadelSecuritiesLogo = function SvgCitadelSecuritiesLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "95px",
    height: "24px",
    viewBox: "0 0 46 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCitadelSecuritiesLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/citadel-securities-logo.ec2f6180.svg";
export { ForwardRef as ReactComponent };